import { combineReducers } from 'redux';
import categories from './ticketCategoriesReducer';
import ticketTypes from './ticketTypesReducer';
import ticketsList from './ticketListReducers';

export default combineReducers({
    categories,
    ticketTypes,
    ticketsList,
});